// src/services/lekhiTopicNames.js

export const SUBJECT_NAMES_MR = {
  grammar: 'व्याकरण',
  math: 'गणित',
  reasoning: 'बुद्धिमत्ता',
  gk: 'सामान्य ज्ञान'
};

export const TOPIC_NAMES_MR = {
  // Grammar
  jati: 'शब्दांच्या जाती',
  vibhakti: 'विभक्ती',
  samas: 'समास',
  alankar: 'अलंकार',
  prayog: 'प्रयोग',
  vachan: 'वचन',
  ling: 'लिंग',
  kaal: 'काळ',
  samanarthi: 'समानार्थी शब्द',
  virudharthi: 'विरुद्धार्थी शब्द',
  vakyaprachar: 'वाक्प्रचार',
  shuddhalekhan: 'शुद्धलेखन',
  viramchinhe: 'विरामचिन्हे',
  sandhi: 'संधी',
  sadrushya: 'शब्दसिद्धी',

  // Math
  simplification: 'सुलभीकरण',
  lcm_hcf: 'मसावि व लसावि',
  percentages: 'टक्केवारी',
  profit_loss: 'नफा-तोटा',
  si_ci: 'सरळव्याज व चक्रवाढ व्याज',
  ratio: 'गुणोत्तर व प्रमाण',
  average: 'सरासरी',
  time_work: 'काळ व काम',
  std: 'वेळ, वेग व अंतर',
  pipes: 'नळ व टाकी',
  area: 'क्षेत्रफळ',
  volume: 'घनफळ',
  geometry: 'भूमिती',
  squares_roots: 'वर्ग व वर्गमूळ',
  divisibility: 'विभाज्यता',

  // Reasoning
  num_series: 'संख्या मालिका',
  letter_series: 'अक्षर मालिका',
  coding_decoding: 'सांकेतिक भाषा व लिपी',
  blood_relations: 'नातेसंबंध',
  direction: 'दिशा',
  classification: 'वर्गीकरण',
  analogies: 'सादृश्य',
  arrangement: 'मांडणी',
  word_arrangement: 'शब्द मांडणी',
  syllogism: 'तर्कक्रिया',
  mirror: 'आरशातील प्रतिमा',
  ranking: 'क्रमवारी',
  di: 'सामग्री विश्लेषण',
  non_verbal: 'अशाब्दिक तर्क',
  problem_solving: 'समस्या निराकरण',

  // GK
  maha_history: 'महाराष्ट्राचा इतिहास',
  indian_history: 'भारताचा इतिहास',
  maha_geography: 'महाराष्ट्राचा भूगोल',
  indian_geography: 'भारताचा भूगोल',
  polity: 'भारतीय राज्यघटना',
  economy: 'अर्थशास्त्र',
  physics: 'भौतिकशास्त्र',
  chemistry: 'रसायनशास्त्र',
  biology: 'जीवशास्त्र',
  sports: 'क्रीडा',
  personalities: 'महत्त्वाच्या व्यक्ती',
  awards: 'पुरस्कार व सन्मान',
  days_years: 'महत्त्वाचे दिवस व वर्षे',
  current_affairs_national: 'राष्ट्रीय चालू घडामोडी',
  current_affairs_maharashtra: 'महाराष्ट्र चालू घडामोडी'
};

export const getSubjectNameMr = (code) => SUBJECT_NAMES_MR[code] || code;
export const getTopicNameMr = (code) => TOPIC_NAMES_MR[code] || code;